import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/components/fashion/FashionBrowsePopup/FashionBrowsePopup.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/components/fashion/FashionNewsletterPopup/FashionNewsletterPopup.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/components/SEO/FBPixels/FBPixels.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/components/SEO/GTag/Gtag.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/components/shared/Footer/FashionFooter/FashionFooter.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/components/shared/Header/FashionHeader/FashionHeader.jsx");
